// import 'babel-polyfill'
import 'es6-promise/auto'
import "@babel/polyfill"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'wowjs/css/libs/animate.css'
import WOW from 'wowjs'
Vue.prototype.$wow = WOW
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
Vue.config.productionTip = false
import './plugins/element.js'
import VueLazyLoad from 'vue-lazyload'
import storage from './utils/storage.js'
import * as Api from './config/http.js';


Vue.use(VueLazyLoad, {
  error: require('./assets/images/loading.png'),
  loading: require('./assets/images/loading.png')
})

var message = (text, type = 'success') => {
  Vue.prototype.$message({
    showClose: true,
    message: text,
    type: type,
    duration: 1000
  })
}

Vue.prototype.$msg = message;
Vue.config.productionTip = false
Vue.prototype.$api = Api;
Vue.prototype.$storage = storage;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    if (store.state.config.shop_name) {
      document.title = to.meta.title + '-' + store.state.config.shop_name
    } else {
      document.title = to.meta.title
    }
  }
  next()
})

if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<=9){
  console.log('请升级浏览器')
}else{
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

